module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_gal-df42a89851f0a4b1d9642a018813ad70.gif";